module.exports = __webpack_public_path__ + "static/media/bpharm6.74162a51.jpg";